import { applyDecorators } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { Type } from 'class-transformer';
import { IsNumber, IsOptional, Max, Min } from 'class-validator';

import { FIELD_INVALID_NUMBER, INVALID_LIMIT_VALUE } from '../constants';
import { BaseDecoratorOptions } from '../types';

type PropertyNumberParams = {
  min?: number;
  max?: number;
  each?: boolean;
} & BaseDecoratorOptions<number | number[]>;

export function ApiPropertyNumber({
  isOptional,
  each,
  min,
  max,
  ...options }: PropertyNumberParams = {}): PropertyDecorator {
  const propertyOptions: ApiPropertyOptions = {
    type: Number,
    example: each ? [1, 2, 3] : 1,
    isArray: each,
    ...(min ? { minimum: min } : {}),
    ...(max ? { maximum: max } : {}),
    ...options,
  };

  return applyDecorators(
    ...(isOptional ? [IsOptional(), ApiPropertyOptional(propertyOptions)] : [ApiProperty(propertyOptions)]),
    IsNumber({}, { message: FIELD_INVALID_NUMBER, each }),
    Type(() => Number),
    ...(!isNaN(min!) ? [Min(min!, { message: INVALID_LIMIT_VALUE, context: { minValue: min }, each })] : []),
    ...(!isNaN(max!) ? [Max(max!, { message: INVALID_LIMIT_VALUE, context: { maxValue: max }, each })] : []),
  );
}
